import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import MDInputTimeout from "../MDInputTimeout";
import MDBox from "../MDBox";
import MDAutocomplete from "../MDAutocomplete";
import MDTypography from "../MDTypography";
import MDButton from "../MDButton";
import { resetDropdown, getAll as getAllReviewPlan, getByIdDropdown as getReviewPlanById } from '../../reducers/reviewPlan';
import ReviewPlanForm from '../../pages/ReviewPlan/ReviewPlanForm';
import { STATUS } from '../../constants/reviewplan.constant';
import { hasAccess } from '../../helpers/access';

function ReviewPlanSelector({ userId, status, label, name, onChange, value, allowAdd, ...rest }) {
  let dispatch = useDispatch()

  const data = useSelector(state => state.reviewPlan.dropdown)
  const [inputValue, setInputValue] = useState('')
  const [dataValue, setDataValue] = useState(null)
  const [createModal, setCreateModal] = useState(false)

  const user = useSelector(state => state.auth.user)
  if (allowAdd) {
    allowAdd = hasAccess(["reviewPlan.create"], user)
  }

  useEffect(() => {
    async function fetchData() {
      try {
        const client = await getReviewPlanById(value)
        setDataValue(client)
      } catch (e) {
        setDataValue(null)
      }
    }
    if (value) fetchData();
  }, [value, dispatch])
  useEffect(() => {
    let params = {
      q: inputValue,
      page: 1,
      limit: 100,
    }
    if (userId) {
      params = {
        ...params,
        userId
      }
    }
    if (status) {
      params = {
        ...params,
        status
      }
    }
    dispatch(resetDropdown())
    dispatch(getAllReviewPlan(params, 'dropdown'))
  }, [inputValue, status, userId, dispatch]);

  const handleChange = (e, result) => {
    setDataValue(result)
    if (typeof onChange !== 'undefined') {
      onChange({
        target: {
          name,
          value: result?.id,
          data: result,
        }
      })
    }
  }

  const handleCreate = (newData) => {
    setDataValue(newData)
    if (typeof onChange !== 'undefined') {
      onChange({
        target: {
          name,
          value: newData?.id,
          data: newData,
        }
      })
    }
  }

  let options = data.data
  if (dataValue && dataValue.id) {
    options = options.filter(o => o.id !== dataValue.id)
    options = [dataValue, ...options]
  }
  return (
    <React.Fragment>
      <MDAutocomplete
        options={options}
        filterOptions={(x) => x}
        autoComplete
        includeInputInList
        filterSelectedOptions
        autoHighlight
        getOptionLabel={(option) => `#${option.id} - Receiver: ${option.receiver.name} - Status: ${STATUS[option.status].text}`}
        renderOption={(props, option) => (
          <MDBox component="li" {...props}>
            #{option.id} - Receiver: {option.receiver.name} - Status: {STATUS[option.status].text}
          </MDBox>
        )}
        value={dataValue}
        onChange={handleChange}
        isOptionEqualToValue={(option, selected) => {
          return option.id === selected.id
        }}
        renderInput={(params) => (
          <MDInputTimeout
            {...params}
            label={label}
            name={name}
            fullWidth
            disabled={!!rest.disabled}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            inputProps={{
              ...params.inputProps,
            }}
          />
        )}
        {...rest}
      />
      {allowAdd && (
        <div style={{ textAlign: 'right' }}>
          <MDTypography variant="caption" fontWeight="medium" color="dark">
            Review plan not found? <MDButton variant="text" size="small" color="primary" onClick={() => setCreateModal(true)}>
              Create one
            </MDButton>
          </MDTypography>
        </div>
      )}
      {createModal && (
        <ReviewPlanForm hideClient data={{ userId }} onClose={() => setCreateModal(false)} onCreate={handleCreate} />
      )}
    </React.Fragment>
  );
}

ReviewPlanSelector.defaultProps = {
  allowAdd: false
}

ReviewPlanSelector.propTypes = {
  userId: PropTypes.number,
  status: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  allowAdd: PropTypes.bool,
}

export default ReviewPlanSelector